// Urdu — RTL
export const ur = {
  'nav.solutions': 'لائیو نشریات کے حل',
  'nav.streamTemplates': 'نشریات کے ٹیمپلیٹس',
  "nav.prepare": "تیاری",
  "nav.events": "تقریبات اور لائیو اسٹریمز",
  "nav.featurePresets": "خصوصیات کی ترتیبات",
  "nav.interact": "تعامل",
  "nav.boards": "انٹرایکٹو بورڈز",
  "nav.measure": "رپورٹس اور تجارت",
  "nav.menu": "مینو کھولیں",
  "nav.closeMenu": "مینو بند کریں",

  'app.name':           'Kardolive',
  'app.tagline':        'صارف پورٹل',
  'app.signOut':        'سائن آؤٹ',

  'login.email':        'ای میل',
  'login.password':     'پاس ورڈ',
  'login.signIn':       'سائن ان کریں',
  'login.signingIn':    'سائن ان ہو رہا ہے…',
  'login.failed':       'سائن ان ناکام',
  'login.newAccount':   'Kardolive پر نئے ہیں؟',
  'login.createAccount':'مفت اکاؤنٹ بنائیں ←',

  'nav.workspace':      'ورک اسپیس',
  'nav.templates':      'ٹیمپلیٹس',
  'nav.live':           'لائیو',
  'nav.rooms':          'رومز اور چیٹ',
  'nav.content':        'مواد',
  'nav.developer':      'ڈویلپر',
  'nav.account':        'اکاؤنٹ',

  'nav.overview':       'جائزہ',
  'nav.projects':       'پراجیکٹس',
  'nav.chat':           'چیٹ کنسول',
  'nav.sessions':       'سیشنز',
  'nav.streams':        'لائیو اسٹریمز',
  'nav.studio':         'اسٹوڈیو',
  'nav.recordings':     'ریکارڈنگز',
  'nav.apiKeys':        'API کیز',
  'nav.webhooks':       'Webhooks',
  'nav.webhookTester':  'Webhook ٹیسٹر',
  'nav.networkTest':    'نیٹ ورک ٹیسٹ',
  'nav.embed':          'ایمبیڈ ویجٹس',
  'nav.sdk':            'SDK اور دستاویزات',
  'nav.docs':           'ڈویلپر دستاویزات',
  'nav.analytics':      'تجزیات',
  'nav.settings':       'ترتیبات',

  'overview.welcome':       'واپسی پر خوش آمدید، {name}',
  'overview.plan':          '{tenant} · {plan} پلان',
  'overview.newStream':     'نئی اسٹریم',
  'overview.kpi.live':           'ابھی لائیو',
  'overview.kpi.live.broadcasting': 'اسٹریمز نشر ہو رہی ہیں',
  'overview.kpi.live.nothing':    'کچھ بھی لائیو نہیں',
  'overview.kpi.total':           'کل اسٹریمز',
  'overview.kpi.total.sub':       'تمام وقتوں میں',
  'overview.kpi.sessions':        'سیشنز · 30 دن',
  'overview.kpi.sessions.sub':    'اشاعت کے واقعات',
  'overview.kpi.recordings':      'ریکارڈنگز',
  'overview.kpi.recordings.sub':  'چلانے کے لیے تیار',
  'overview.recentStreams':       'حالیہ اسٹریمز',
  'overview.recentSessions':      'حالیہ سیشنز',
  'overview.viewAll':             'سب دیکھیں ←',
  'overview.empty.title':         'ابھی تک کوئی اسٹریم نہیں',
  'overview.empty.body':          'نشریات شروع کرنے کے لیے اپنی پہلی اسٹریم بنائیں۔',
  'overview.empty.action':        'اسٹریم بنائیں',
  'overview.noSessions':          'ابھی تک کوئی سیشن نہیں',

  'status.live':        'لائیو',
  'status.idle':        'غیر فعال',
  'status.ended':       'ختم',
  'status.archived':    'محفوظ شدہ',

  'common.save':        'محفوظ کریں',
  'common.cancel':      'منسوخ کریں',
  'common.delete':      'حذف کریں',
  'common.edit':        'ترمیم',
  'common.create':      'بنائیں',
  'common.confirm':     'تصدیق کریں',
  'common.loading':     'لوڈ ہو رہا ہے…',
  'common.error':       'خرابی',
  'common.retry':       'دوبارہ کوشش کریں',

  // Dashboard navigation and account controls.
  "nav.skipContent": "صفحے کے مواد پر جائیں",
  "nav.scenarios": "استعمال کی صورتیں",
  "nav.premieres": "پریمیئرز",
  "nav.clips": "کلپس",
  "dashboard.account": "اکاؤنٹ",
  "dashboard.language": "زبان",
  "dashboard.appearance": "ظاہری انداز",
  "nav.allStreams": "تمام نشریات",
  "nav.destinations": "نشریات کی منزلیں",
  "nav.ecommerce": "ای کامرس",
  "nav.products": "مصنوعات",
  "nav.services": "خدمات",
  "nav.collections": "مجموعے",
  "nav.orders": "آرڈرز",
  "nav.commerceSettings": "تجارت کی ترتیبات",
  "nav.engagement": "تعامل",
  "theme.light": "روشن انداز پر جائیں",
  "theme.dark": "گہرے انداز پر جائیں",
  "role.owner": "مالک",
  "role.admin": "منتظم",
  "role.member": "رکن",
  "role.viewer": "ناظر",

  // Live Stream page content: never translate stored event names or API values.
  "streams.active": "فعال",
  "streams.archived": "محفوظ شدہ",
  "streams.monitor": "نشریاتی ذرائع کی نگرانی",
  "streams.create": "براہ راست نشریات بنائیں",
  "streams.list": "فہرست",
  "streams.grid": "گرڈ",
  "streams.view": "نشریات کا منظر",
  "streams.searchLabel": "ایونٹس تلاش کریں",
  "streams.searchHint": "ایونٹ کا نام تلاش کریں",
  "streams.solutionFilter": "قسم کے لحاظ سے ایونٹس چھانٹیں",
  "streams.statusFilter": "حالت کے لحاظ سے ایونٹس چھانٹیں",
  "streams.dateFilter": "تخلیق کی تاریخ کے لحاظ سے چھانٹیں",
  "streams.allSolutions": "تمام اقسام",
  "streams.custom": "موجودہ یا حسب ضرورت ترتیب",
  "streams.allStatuses": "تمام حالتیں",
  "streams.anyTime": "تخلیق کی کوئی بھی تاریخ",
  "streams.last7": "گزشتہ ۷ دن میں بنائے گئے",
  "streams.last30": "گزشتہ ۳۰ دن میں بنائے گئے",
  "streams.count": "{total} میں سے {shown} ایونٹس دکھائے جا رہے ہیں",
  "streams.noMatch": "فلٹرز کے مطابق کوئی ایونٹ نہیں ملا۔",
  "streams.clearFilters": "فلٹرز صاف کریں",
  "streams.refreshFailed": "نشریات کی فہرست تازہ نہیں ہو سکی",
  "streams.loadFailed": "نشریات لوڈ نہیں ہو سکیں",
  "streams.stale": "آخری بار لوڈ کی گئی فہرست دکھائی جا رہی ہے۔ حالت بدل چکی ہو سکتی ہے۔",
  "streams.connectionHint": "اپنا کنکشن چیک کریں اور فہرست دوبارہ لوڈ کریں۔",
  "streams.retrying": "دوبارہ کوشش جاری ہے…",
  "streams.retry": "دوبارہ کوشش کریں",
  "streams.restoreFailed": "نشریات بحال نہیں ہو سکیں",
  "streams.restoreHint": "دوبارہ کوشش سے پہلے کنکشن چیک کریں اور تازہ حالت دیکھنے کے لیے فہرست تازہ کریں۔",
  "streams.unused": "غیر استعمال شدہ نشریات: {count}",
  "streams.unusedHint": "کوئی براڈکاسٹ یا ری پلے نہیں۔ فہرست منظم کرنے کے لیے محفوظ کریں؛ کچھ حذف نہیں ہوگا۔",
  "streams.reviewArchive": "جائزہ لیں اور محفوظ کریں",
  "streams.loading": "نشریات لوڈ ہو رہی ہیں…",
  "streams.archiveEmpty": "کوئی محفوظ شدہ نشریات نہیں۔ محفوظ نشریات اور ان کے ری پلے بحالی تک یہاں رہتے ہیں۔",
  "streams.restore": "بحال کریں",
  "streams.firstTitle": "اپنی پہلی نشریات بنائیں",
  "streams.firstBody": "فروخت، کلاس یا خدمت کے لیے ترتیب منتخب کریں یا خالی نشریات سے شروع کریں۔ براؤزر، فون یا OBS سے نشر کریں۔",
  "streams.blank": "خالی نشریات",
  "streams.broadcasts": "براڈکاسٹس: {count}",
  "streams.replays": "ری پلے: {count}",
  "streams.sessions": "سیشنز: {count}",
  "streams.recordings": "ریکارڈنگز: {count}",
  "streams.mode.BROADCAST": "براڈکاسٹ",
  "streams.mode.LOW_LATENCY": "کم تاخیر",
  "streams.mode.REALTIME": "حقیقی وقت",
  "streams.key": "کلید",
  "streams.archiveTitle": "غیر استعمال شدہ نشریات محفوظ کریں",
  "streams.archiveHint": "یہ نشریات کبھی نشر نہیں ہوئیں۔ محفوظ شدہ ٹیب سے کسی بھی وقت بحال کر سکتے ہیں۔",
  "streams.archiveFailed": "{count} نشریات محفوظ نہیں ہو سکیں؛ ممکن ہے وہ براہ راست شروع ہو گئی ہوں۔ باقی محفوظ کر دی گئی ہیں۔",
  "streams.archiving": "محفوظ کیا جا رہا ہے…",
  "streams.archiveCount": "{count} محفوظ کریں",
  "streamType.webinar": "کاروباری ویبینار اور افتتاح",
  "streamType.classroom": "کلاسیں اور تدریس",
  "streamType.training": "اداروں کی تربیت",
  "streamType.conference": "کانفرنسیں اور نمائشیں",
  "streamType.shopping": "براہ راست خریداری",
  "streamType.auction": "براہ راست نیلامی",
  "streamType.consultation": "نجی مشاورت",
  "streamType.creator": "تخلیق کاروں اور کمیونٹی کی نشریات",
  "streamType.audio": "آڈیو رومز اور پوڈکاسٹ",
  "streamType.sports": "کھیل اور ای اسپورٹس",
  "streamType.performance": "کنسرٹ اور پرفارمنس",
  "streamType.community": "عبادت اور چندہ جمع کرنا",
  "streamType.tour": "دورے اور عملی مظاہرے",
  "streamType.fitness": "فٹنس اور ورکشاپس",
  "streamType.public-meeting": "خبریں اور عوامی اجلاس",
  "streamType.continuous": "مسلسل چینلز اور کیمرے",
  "streams.close": "بند کریں",
};
